/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  CaseModel,
  DeclinedAssignmentsExportRequest,
  ExportDeleteInvoiceDataParams,
  ExportDownloadGdprExportParams,
  ExportDownloadInvoiceDataFileParams,
  ExportExportApprovedAssignmentsParams,
  ExportExportAvailabilityDataParams,
  ExportExportCircleKFuelReportParams,
  ExportExportHogiaSalaryParams,
  ExportExportHomeDeliveryDelayDataParams,
  ExportExportInvoiceDataParams,
  ExportExportInvoiceStatsDataParams,
  ExportExportOBDNotUsedParams,
  ExportExportRawAssignmentDataParams,
  ExportExportRestingTimesParams,
  ExportExportSalaryParams,
  ExportExportTBParams,
  ExportExportUserRatingDataParams,
  ExportExportZoranInvoiceStatisticsParams,
  ExportGetClosedNotYetInvoicedCasesParams,
  ExportGetGdprExportStatusParams,
  ExportGetGdprExportsByUserParams,
  ExportGetInvoiceDataParams,
  ExportUsersRequest,
  GdprExportStatusDto,
  InitiateGdprExportRequest,
  InitiateGdprExportResponse,
  InvoiceDataModel,
  KPIFilterRequestModelBody,
  ManagementReportRequest,
  ProblemDetails,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useExportExportZoranInvoiceStatisticsHook = () => {
  const exportExportZoranInvoiceStatistics = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportZoranInvoiceStatisticsParams) => {
      return exportExportZoranInvoiceStatistics({
        url: `/api/Export/ExportZoranInvoiceStatistics`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportZoranInvoiceStatistics]
  );
};

export const useExportExportZoranInvoiceStatisticsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportZoranInvoiceStatisticsHook>>
    >,
    TError,
    { params?: ExportExportZoranInvoiceStatisticsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportZoranInvoiceStatisticsHook>>
  >,
  TError,
  { params?: ExportExportZoranInvoiceStatisticsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportZoranInvoiceStatistics =
    useExportExportZoranInvoiceStatisticsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportZoranInvoiceStatisticsHook>>
    >,
    { params?: ExportExportZoranInvoiceStatisticsParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportZoranInvoiceStatistics(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportZoranInvoiceStatisticsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportZoranInvoiceStatisticsHook>>
  >
>;

export type ExportExportZoranInvoiceStatisticsMutationError = unknown;

export const useExportExportZoranInvoiceStatistics = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportZoranInvoiceStatisticsHook>>
    >,
    TError,
    { params?: ExportExportZoranInvoiceStatisticsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportZoranInvoiceStatisticsHook>>
  >,
  TError,
  { params?: ExportExportZoranInvoiceStatisticsParams },
  TContext
> => {
  const mutationOptions =
    useExportExportZoranInvoiceStatisticsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportInvoiceDataHook = () => {
  const exportExportInvoiceData = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportInvoiceDataParams) => {
      return exportExportInvoiceData({
        url: `/api/Export/ExportInvoiceData`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportInvoiceData]
  );
};

export const useExportExportInvoiceDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceDataHook>>>,
    TError,
    { params?: ExportExportInvoiceDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceDataHook>>>,
  TError,
  { params?: ExportExportInvoiceDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportInvoiceData = useExportExportInvoiceDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceDataHook>>>,
    { params?: ExportExportInvoiceDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportInvoiceData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportInvoiceDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceDataHook>>>
>;

export type ExportExportInvoiceDataMutationError = unknown;

export const useExportExportInvoiceData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceDataHook>>>,
    TError,
    { params?: ExportExportInvoiceDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceDataHook>>>,
  TError,
  { params?: ExportExportInvoiceDataParams },
  TContext
> => {
  const mutationOptions = useExportExportInvoiceDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportInvoiceStatsDataHook = () => {
  const exportExportInvoiceStatsData = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportInvoiceStatsDataParams) => {
      return exportExportInvoiceStatsData({
        url: `/api/Export/ExportInvoiceStatsData`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportInvoiceStatsData]
  );
};

export const useExportExportInvoiceStatsDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceStatsDataHook>>>,
    TError,
    { params?: ExportExportInvoiceStatsDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceStatsDataHook>>>,
  TError,
  { params?: ExportExportInvoiceStatsDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportInvoiceStatsData = useExportExportInvoiceStatsDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceStatsDataHook>>>,
    { params?: ExportExportInvoiceStatsDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportInvoiceStatsData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportInvoiceStatsDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceStatsDataHook>>>
>;

export type ExportExportInvoiceStatsDataMutationError = unknown;

export const useExportExportInvoiceStatsData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceStatsDataHook>>>,
    TError,
    { params?: ExportExportInvoiceStatsDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportInvoiceStatsDataHook>>>,
  TError,
  { params?: ExportExportInvoiceStatsDataParams },
  TContext
> => {
  const mutationOptions =
    useExportExportInvoiceStatsDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportGetClosedNotYetInvoicedCasesHook = () => {
  const exportGetClosedNotYetInvoicedCases = useCustomInstance<CaseModel[]>();

  return useCallback(
    (params?: ExportGetClosedNotYetInvoicedCasesParams) => {
      return exportGetClosedNotYetInvoicedCases({
        url: `/api/Export/GetClosedNotYetInvoicedCases`,
        method: 'POST',
        params,
      });
    },
    [exportGetClosedNotYetInvoicedCases]
  );
};

export const useExportGetClosedNotYetInvoicedCasesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportGetClosedNotYetInvoicedCasesHook>>
    >,
    TError,
    { params?: ExportGetClosedNotYetInvoicedCasesParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useExportGetClosedNotYetInvoicedCasesHook>>
  >,
  TError,
  { params?: ExportGetClosedNotYetInvoicedCasesParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportGetClosedNotYetInvoicedCases =
    useExportGetClosedNotYetInvoicedCasesHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportGetClosedNotYetInvoicedCasesHook>>
    >,
    { params?: ExportGetClosedNotYetInvoicedCasesParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportGetClosedNotYetInvoicedCases(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportGetClosedNotYetInvoicedCasesMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useExportGetClosedNotYetInvoicedCasesHook>>
  >
>;

export type ExportGetClosedNotYetInvoicedCasesMutationError = unknown;

export const useExportGetClosedNotYetInvoicedCases = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportGetClosedNotYetInvoicedCasesHook>>
    >,
    TError,
    { params?: ExportGetClosedNotYetInvoicedCasesParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useExportGetClosedNotYetInvoicedCasesHook>>
  >,
  TError,
  { params?: ExportGetClosedNotYetInvoicedCasesParams },
  TContext
> => {
  const mutationOptions =
    useExportGetClosedNotYetInvoicedCasesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportDownloadInvoiceDataFileHook = () => {
  const exportDownloadInvoiceDataFile = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportDownloadInvoiceDataFileParams) => {
      return exportDownloadInvoiceDataFile({
        url: `/api/Export/DownloadInvoiceDataFile`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportDownloadInvoiceDataFile]
  );
};

export const useExportDownloadInvoiceDataFileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportDownloadInvoiceDataFileHook>>
    >,
    TError,
    { params?: ExportDownloadInvoiceDataFileParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportDownloadInvoiceDataFileHook>>>,
  TError,
  { params?: ExportDownloadInvoiceDataFileParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportDownloadInvoiceDataFile = useExportDownloadInvoiceDataFileHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportDownloadInvoiceDataFileHook>>
    >,
    { params?: ExportDownloadInvoiceDataFileParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportDownloadInvoiceDataFile(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportDownloadInvoiceDataFileMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportDownloadInvoiceDataFileHook>>>
>;

export type ExportDownloadInvoiceDataFileMutationError = unknown;

export const useExportDownloadInvoiceDataFile = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportDownloadInvoiceDataFileHook>>
    >,
    TError,
    { params?: ExportDownloadInvoiceDataFileParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportDownloadInvoiceDataFileHook>>>,
  TError,
  { params?: ExportDownloadInvoiceDataFileParams },
  TContext
> => {
  const mutationOptions =
    useExportDownloadInvoiceDataFileMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportGetInvoiceDataHook = () => {
  const exportGetInvoiceData = useCustomInstance<InvoiceDataModel[]>();

  return useCallback(
    (params?: ExportGetInvoiceDataParams) => {
      return exportGetInvoiceData({
        url: `/api/Export/GetInvoiceData`,
        method: 'POST',
        params,
      });
    },
    [exportGetInvoiceData]
  );
};

export const useExportGetInvoiceDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportGetInvoiceDataHook>>>,
    TError,
    { params?: ExportGetInvoiceDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportGetInvoiceDataHook>>>,
  TError,
  { params?: ExportGetInvoiceDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportGetInvoiceData = useExportGetInvoiceDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportGetInvoiceDataHook>>>,
    { params?: ExportGetInvoiceDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportGetInvoiceData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportGetInvoiceDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportGetInvoiceDataHook>>>
>;

export type ExportGetInvoiceDataMutationError = unknown;

export const useExportGetInvoiceData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportGetInvoiceDataHook>>>,
    TError,
    { params?: ExportGetInvoiceDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportGetInvoiceDataHook>>>,
  TError,
  { params?: ExportGetInvoiceDataParams },
  TContext
> => {
  const mutationOptions = useExportGetInvoiceDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportDeleteInvoiceDataHook = () => {
  const exportDeleteInvoiceData = useCustomInstance<void>();

  return useCallback(
    (params?: ExportDeleteInvoiceDataParams) => {
      return exportDeleteInvoiceData({
        url: `/api/Export/DeleteInvoiceData`,
        method: 'POST',
        params,
      });
    },
    [exportDeleteInvoiceData]
  );
};

export const useExportDeleteInvoiceDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportDeleteInvoiceDataHook>>>,
    TError,
    { params?: ExportDeleteInvoiceDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportDeleteInvoiceDataHook>>>,
  TError,
  { params?: ExportDeleteInvoiceDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportDeleteInvoiceData = useExportDeleteInvoiceDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportDeleteInvoiceDataHook>>>,
    { params?: ExportDeleteInvoiceDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportDeleteInvoiceData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportDeleteInvoiceDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportDeleteInvoiceDataHook>>>
>;

export type ExportDeleteInvoiceDataMutationError = unknown;

export const useExportDeleteInvoiceData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportDeleteInvoiceDataHook>>>,
    TError,
    { params?: ExportDeleteInvoiceDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportDeleteInvoiceDataHook>>>,
  TError,
  { params?: ExportDeleteInvoiceDataParams },
  TContext
> => {
  const mutationOptions = useExportDeleteInvoiceDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportPendingHook = () => {
  const exportExportPending = useCustomInstance<Blob>();

  return useCallback(() => {
    return exportExportPending({
      url: `/api/Export/ExportPending`,
      method: 'POST',
      responseType: 'blob',
    });
  }, [exportExportPending]);
};

export const useExportExportPendingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportPendingHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportPendingHook>>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportPending = useExportExportPendingHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportPendingHook>>>,
    void
  > = () => {
    return exportExportPending();
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportPendingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportPendingHook>>>
>;

export type ExportExportPendingMutationError = unknown;

export const useExportExportPending = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportPendingHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportPendingHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = useExportExportPendingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportSalaryHook = () => {
  const exportExportSalary = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportSalaryParams) => {
      return exportExportSalary({
        url: `/api/Export/ExportSalary`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportSalary]
  );
};

export const useExportExportSalaryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportSalaryHook>>>,
    TError,
    { params?: ExportExportSalaryParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportSalaryHook>>>,
  TError,
  { params?: ExportExportSalaryParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportSalary = useExportExportSalaryHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportSalaryHook>>>,
    { params?: ExportExportSalaryParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportSalary(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportSalaryMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportSalaryHook>>>
>;

export type ExportExportSalaryMutationError = unknown;

export const useExportExportSalary = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportSalaryHook>>>,
    TError,
    { params?: ExportExportSalaryParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportSalaryHook>>>,
  TError,
  { params?: ExportExportSalaryParams },
  TContext
> => {
  const mutationOptions = useExportExportSalaryMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportCircleKFuelReportHook = () => {
  const exportExportCircleKFuelReport = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportCircleKFuelReportParams) => {
      return exportExportCircleKFuelReport({
        url: `/api/Export/ExportCircleKFuelReport`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportCircleKFuelReport]
  );
};

export const useExportExportCircleKFuelReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportCircleKFuelReportHook>>
    >,
    TError,
    { params?: ExportExportCircleKFuelReportParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportCircleKFuelReportHook>>>,
  TError,
  { params?: ExportExportCircleKFuelReportParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportCircleKFuelReport = useExportExportCircleKFuelReportHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportCircleKFuelReportHook>>
    >,
    { params?: ExportExportCircleKFuelReportParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportCircleKFuelReport(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportCircleKFuelReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportCircleKFuelReportHook>>>
>;

export type ExportExportCircleKFuelReportMutationError = unknown;

export const useExportExportCircleKFuelReport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportCircleKFuelReportHook>>
    >,
    TError,
    { params?: ExportExportCircleKFuelReportParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportCircleKFuelReportHook>>>,
  TError,
  { params?: ExportExportCircleKFuelReportParams },
  TContext
> => {
  const mutationOptions =
    useExportExportCircleKFuelReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportHogiaSalaryHook = () => {
  const exportExportHogiaSalary = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportHogiaSalaryParams) => {
      return exportExportHogiaSalary({
        url: `/api/Export/ExportHogiaSalary`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportHogiaSalary]
  );
};

export const useExportExportHogiaSalaryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportHogiaSalaryHook>>>,
    TError,
    { params?: ExportExportHogiaSalaryParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportHogiaSalaryHook>>>,
  TError,
  { params?: ExportExportHogiaSalaryParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportHogiaSalary = useExportExportHogiaSalaryHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportHogiaSalaryHook>>>,
    { params?: ExportExportHogiaSalaryParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportHogiaSalary(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportHogiaSalaryMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportHogiaSalaryHook>>>
>;

export type ExportExportHogiaSalaryMutationError = unknown;

export const useExportExportHogiaSalary = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportHogiaSalaryHook>>>,
    TError,
    { params?: ExportExportHogiaSalaryParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportHogiaSalaryHook>>>,
  TError,
  { params?: ExportExportHogiaSalaryParams },
  TContext
> => {
  const mutationOptions = useExportExportHogiaSalaryMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportRestingTimesHook = () => {
  const exportExportRestingTimes = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportRestingTimesParams) => {
      return exportExportRestingTimes({
        url: `/api/Export/ExportRestingTimes`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportRestingTimes]
  );
};

export const useExportExportRestingTimesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportRestingTimesHook>>>,
    TError,
    { params?: ExportExportRestingTimesParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportRestingTimesHook>>>,
  TError,
  { params?: ExportExportRestingTimesParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportRestingTimes = useExportExportRestingTimesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportRestingTimesHook>>>,
    { params?: ExportExportRestingTimesParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportRestingTimes(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportRestingTimesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportRestingTimesHook>>>
>;

export type ExportExportRestingTimesMutationError = unknown;

export const useExportExportRestingTimes = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportRestingTimesHook>>>,
    TError,
    { params?: ExportExportRestingTimesParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportRestingTimesHook>>>,
  TError,
  { params?: ExportExportRestingTimesParams },
  TContext
> => {
  const mutationOptions = useExportExportRestingTimesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportAvailabilityDataHook = () => {
  const exportExportAvailabilityData = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportAvailabilityDataParams) => {
      return exportExportAvailabilityData({
        url: `/api/Export/ExportAvailabilityData`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportAvailabilityData]
  );
};

export const useExportExportAvailabilityDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportAvailabilityDataHook>>>,
    TError,
    { params?: ExportExportAvailabilityDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportAvailabilityDataHook>>>,
  TError,
  { params?: ExportExportAvailabilityDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportAvailabilityData = useExportExportAvailabilityDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportAvailabilityDataHook>>>,
    { params?: ExportExportAvailabilityDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportAvailabilityData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportAvailabilityDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportAvailabilityDataHook>>>
>;

export type ExportExportAvailabilityDataMutationError = unknown;

export const useExportExportAvailabilityData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportAvailabilityDataHook>>>,
    TError,
    { params?: ExportExportAvailabilityDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportAvailabilityDataHook>>>,
  TError,
  { params?: ExportExportAvailabilityDataParams },
  TContext
> => {
  const mutationOptions =
    useExportExportAvailabilityDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportUserRatingDataHook = () => {
  const exportExportUserRatingData = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportUserRatingDataParams) => {
      return exportExportUserRatingData({
        url: `/api/Export/ExportUserRatingData`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportUserRatingData]
  );
};

export const useExportExportUserRatingDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportUserRatingDataHook>>>,
    TError,
    { params?: ExportExportUserRatingDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportUserRatingDataHook>>>,
  TError,
  { params?: ExportExportUserRatingDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportUserRatingData = useExportExportUserRatingDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportUserRatingDataHook>>>,
    { params?: ExportExportUserRatingDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportUserRatingData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportUserRatingDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportUserRatingDataHook>>>
>;

export type ExportExportUserRatingDataMutationError = unknown;

export const useExportExportUserRatingData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportUserRatingDataHook>>>,
    TError,
    { params?: ExportExportUserRatingDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportUserRatingDataHook>>>,
  TError,
  { params?: ExportExportUserRatingDataParams },
  TContext
> => {
  const mutationOptions = useExportExportUserRatingDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportHomeDeliveryDelayDataHook = () => {
  const exportExportHomeDeliveryDelayData = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportHomeDeliveryDelayDataParams) => {
      return exportExportHomeDeliveryDelayData({
        url: `/api/Export/ExportHomeDeliveryDelayData`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportHomeDeliveryDelayData]
  );
};

export const useExportExportHomeDeliveryDelayDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportHomeDeliveryDelayDataHook>>
    >,
    TError,
    { params?: ExportExportHomeDeliveryDelayDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportHomeDeliveryDelayDataHook>>
  >,
  TError,
  { params?: ExportExportHomeDeliveryDelayDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportHomeDeliveryDelayData =
    useExportExportHomeDeliveryDelayDataHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportHomeDeliveryDelayDataHook>>
    >,
    { params?: ExportExportHomeDeliveryDelayDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportHomeDeliveryDelayData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportHomeDeliveryDelayDataMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportHomeDeliveryDelayDataHook>>
  >
>;

export type ExportExportHomeDeliveryDelayDataMutationError = unknown;

export const useExportExportHomeDeliveryDelayData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportHomeDeliveryDelayDataHook>>
    >,
    TError,
    { params?: ExportExportHomeDeliveryDelayDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportHomeDeliveryDelayDataHook>>
  >,
  TError,
  { params?: ExportExportHomeDeliveryDelayDataParams },
  TContext
> => {
  const mutationOptions =
    useExportExportHomeDeliveryDelayDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportApprovedAssignmentsHook = () => {
  const exportExportApprovedAssignments = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportApprovedAssignmentsParams) => {
      return exportExportApprovedAssignments({
        url: `/api/Export/ExportApprovedAssignments`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportApprovedAssignments]
  );
};

export const useExportExportApprovedAssignmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportApprovedAssignmentsHook>>
    >,
    TError,
    { params?: ExportExportApprovedAssignmentsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportApprovedAssignmentsHook>>
  >,
  TError,
  { params?: ExportExportApprovedAssignmentsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportApprovedAssignments =
    useExportExportApprovedAssignmentsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportApprovedAssignmentsHook>>
    >,
    { params?: ExportExportApprovedAssignmentsParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportApprovedAssignments(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportApprovedAssignmentsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportApprovedAssignmentsHook>>>
>;

export type ExportExportApprovedAssignmentsMutationError = unknown;

export const useExportExportApprovedAssignments = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportApprovedAssignmentsHook>>
    >,
    TError,
    { params?: ExportExportApprovedAssignmentsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportApprovedAssignmentsHook>>
  >,
  TError,
  { params?: ExportExportApprovedAssignmentsParams },
  TContext
> => {
  const mutationOptions =
    useExportExportApprovedAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportRawAssignmentDataHook = () => {
  const exportExportRawAssignmentData = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportRawAssignmentDataParams) => {
      return exportExportRawAssignmentData({
        url: `/api/Export/ExportRawAssignmentData`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [exportExportRawAssignmentData]
  );
};

export const useExportExportRawAssignmentDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportRawAssignmentDataHook>>
    >,
    TError,
    { params?: ExportExportRawAssignmentDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportRawAssignmentDataHook>>>,
  TError,
  { params?: ExportExportRawAssignmentDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportRawAssignmentData = useExportExportRawAssignmentDataHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportRawAssignmentDataHook>>
    >,
    { params?: ExportExportRawAssignmentDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return exportExportRawAssignmentData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportRawAssignmentDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportRawAssignmentDataHook>>>
>;

export type ExportExportRawAssignmentDataMutationError = unknown;

export const useExportExportRawAssignmentData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportRawAssignmentDataHook>>
    >,
    TError,
    { params?: ExportExportRawAssignmentDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportRawAssignmentDataHook>>>,
  TError,
  { params?: ExportExportRawAssignmentDataParams },
  TContext
> => {
  const mutationOptions =
    useExportExportRawAssignmentDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportTBHook = () => {
  const exportExportTB = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportTBParams, signal?: AbortSignal) => {
      return exportExportTB({
        url: `/api/Export/ExportTB`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
      });
    },
    [exportExportTB]
  );
};

export const getExportExportTBQueryKey = (params?: ExportExportTBParams) => {
  return [`/api/Export/ExportTB`, ...(params ? [params] : [])] as const;
};

export const useExportExportTBQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>,
  TError = unknown,
>(
  params?: ExportExportTBParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportExportTBQueryKey(params);

  const exportExportTB = useExportExportTBHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>
  > = ({ signal }) => exportExportTB(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportExportTBQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>
>;
export type ExportExportTBQueryError = unknown;

export const useExportExportTB = <
  TData = Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>,
  TError = unknown,
>(
  params?: ExportExportTBParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportExportTBHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExportExportTBQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExportExportOBDNotUsedHook = () => {
  const exportExportOBDNotUsed = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportExportOBDNotUsedParams, signal?: AbortSignal) => {
      return exportExportOBDNotUsed({
        url: `/api/Export/ExportOBDNotUsed`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
      });
    },
    [exportExportOBDNotUsed]
  );
};

export const getExportExportOBDNotUsedQueryKey = (
  params?: ExportExportOBDNotUsedParams
) => {
  return [`/api/Export/ExportOBDNotUsed`, ...(params ? [params] : [])] as const;
};

export const useExportExportOBDNotUsedQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>,
  TError = unknown,
>(
  params?: ExportExportOBDNotUsedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportExportOBDNotUsedQueryKey(params);

  const exportExportOBDNotUsed = useExportExportOBDNotUsedHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>
  > = ({ signal }) => exportExportOBDNotUsed(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportExportOBDNotUsedQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>
>;
export type ExportExportOBDNotUsedQueryError = unknown;

export const useExportExportOBDNotUsed = <
  TData = Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>,
  TError = unknown,
>(
  params?: ExportExportOBDNotUsedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportExportOBDNotUsedHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExportExportOBDNotUsedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExportExportCancellationsHook = () => {
  const exportExportCancellations = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportCancellations({
        url: `/api/Export/ExportCancellations`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportCancellations]
  );
};

export const useExportExportCancellationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportCancellationsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportCancellationsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportCancellations = useExportExportCancellationsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportCancellationsHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportCancellations(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportCancellationsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportCancellationsHook>>>
>;
export type ExportExportCancellationsMutationBody = KPIFilterRequestModelBody;
export type ExportExportCancellationsMutationError = unknown;

export const useExportExportCancellations = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportCancellationsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportCancellationsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useExportExportCancellationsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportDeviationJobsHook = () => {
  const exportExportDeviationJobs = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportDeviationJobs({
        url: `/api/Export/ExportDeviationJobs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportDeviationJobs]
  );
};

export const useExportExportDeviationJobsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportDeviationJobsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportDeviationJobsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportDeviationJobs = useExportExportDeviationJobsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportDeviationJobsHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportDeviationJobs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportDeviationJobsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportDeviationJobsHook>>>
>;
export type ExportExportDeviationJobsMutationBody = KPIFilterRequestModelBody;
export type ExportExportDeviationJobsMutationError = unknown;

export const useExportExportDeviationJobs = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportDeviationJobsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportDeviationJobsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useExportExportDeviationJobsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportCasesBySupplierHook = () => {
  const exportExportCasesBySupplier = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportCasesBySupplier({
        url: `/api/Export/ExportCasesBySupplier`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportCasesBySupplier]
  );
};

export const useExportExportCasesBySupplierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportCasesBySupplierHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportCasesBySupplierHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportCasesBySupplier = useExportExportCasesBySupplierHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportCasesBySupplierHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportCasesBySupplier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportCasesBySupplierMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportCasesBySupplierHook>>>
>;
export type ExportExportCasesBySupplierMutationBody = KPIFilterRequestModelBody;
export type ExportExportCasesBySupplierMutationError = unknown;

export const useExportExportCasesBySupplier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportCasesBySupplierHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportCasesBySupplierHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useExportExportCasesBySupplierMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook =
  () => {
    const exportExportAverageDrivingDistanceByCaseTypeAndCounty =
      useCustomInstance<Blob>();

    return useCallback(
      (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
        return exportExportAverageDrivingDistanceByCaseTypeAndCounty({
          url: `/api/Export/ExportAverageDrivingDistanceByCaseTypeAndCounty`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: kPIFilterRequestModelBody,
          responseType: 'blob',
        });
      },
      [exportExportAverageDrivingDistanceByCaseTypeAndCounty]
    );
  };

export const useExportExportAverageDrivingDistanceByCaseTypeAndCountyMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook
          >
        >
      >,
      TError,
      { data: KPIFilterRequestModelBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook
        >
      >
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const exportExportAverageDrivingDistanceByCaseTypeAndCounty =
      useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook
          >
        >
      >,
      { data: KPIFilterRequestModelBody }
    > = (props) => {
      const { data } = props ?? {};

      return exportExportAverageDrivingDistanceByCaseTypeAndCounty(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExportExportAverageDrivingDistanceByCaseTypeAndCountyMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook
        >
      >
    >
  >;
export type ExportExportAverageDrivingDistanceByCaseTypeAndCountyMutationBody =
  KPIFilterRequestModelBody;
export type ExportExportAverageDrivingDistanceByCaseTypeAndCountyMutationError =
  unknown;

export const useExportExportAverageDrivingDistanceByCaseTypeAndCounty = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook
        >
      >
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useExportExportAverageDrivingDistanceByCaseTypeAndCountyHook
      >
    >
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useExportExportAverageDrivingDistanceByCaseTypeAndCountyMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useExportExportVehicleFaultsHook = () => {
  const exportExportVehicleFaults = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportVehicleFaults({
        url: `/api/Export/ExportVehicleFaults`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportVehicleFaults]
  );
};

export const useExportExportVehicleFaultsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportVehicleFaultsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportVehicleFaultsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportVehicleFaults = useExportExportVehicleFaultsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportVehicleFaultsHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportVehicleFaults(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportVehicleFaultsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportVehicleFaultsHook>>>
>;
export type ExportExportVehicleFaultsMutationBody = KPIFilterRequestModelBody;
export type ExportExportVehicleFaultsMutationError = unknown;

export const useExportExportVehicleFaults = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportVehicleFaultsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportVehicleFaultsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useExportExportVehicleFaultsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportHRSpeedingReportHook = () => {
  const exportExportHRSpeedingReport = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportHRSpeedingReport({
        url: `/api/Export/ExportHRSpeedingReport`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportHRSpeedingReport]
  );
};

export const useExportExportHRSpeedingReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportHRSpeedingReportHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportHRSpeedingReportHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportHRSpeedingReport = useExportExportHRSpeedingReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportHRSpeedingReportHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportHRSpeedingReport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportHRSpeedingReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportHRSpeedingReportHook>>>
>;
export type ExportExportHRSpeedingReportMutationBody =
  KPIFilterRequestModelBody;
export type ExportExportHRSpeedingReportMutationError = unknown;

export const useExportExportHRSpeedingReport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportHRSpeedingReportHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportHRSpeedingReportHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useExportExportHRSpeedingReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportManagementReportHook = () => {
  const exportExportManagementReport = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportManagementReport({
        url: `/api/Export/ExportManagementReport`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportManagementReport]
  );
};

export const useExportExportManagementReportMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportManagementReportHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportManagementReportHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportManagementReport = useExportExportManagementReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportManagementReportHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportManagementReport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportManagementReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportManagementReportHook>>>
>;
export type ExportExportManagementReportMutationBody =
  KPIFilterRequestModelBody;
export type ExportExportManagementReportMutationError = ProblemDetails;

export const useExportExportManagementReport = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportManagementReportHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportManagementReportHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useExportExportManagementReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportManagementReportWordHook = () => {
  const exportExportManagementReportWord = useCustomInstance<Blob>();

  return useCallback(
    (managementReportRequest: ManagementReportRequest) => {
      return exportExportManagementReportWord({
        url: `/api/Export/ExportManagementReportWord`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: managementReportRequest,
        responseType: 'blob',
      });
    },
    [exportExportManagementReportWord]
  );
};

export const useExportExportManagementReportWordMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportManagementReportWordHook>>
    >,
    TError,
    { data: ManagementReportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportManagementReportWordHook>>
  >,
  TError,
  { data: ManagementReportRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportManagementReportWord =
    useExportExportManagementReportWordHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportManagementReportWordHook>>
    >,
    { data: ManagementReportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportManagementReportWord(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportManagementReportWordMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportManagementReportWordHook>>
  >
>;
export type ExportExportManagementReportWordMutationBody =
  ManagementReportRequest;
export type ExportExportManagementReportWordMutationError = ProblemDetails;

export const useExportExportManagementReportWord = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportManagementReportWordHook>>
    >,
    TError,
    { data: ManagementReportRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportManagementReportWordHook>>
  >,
  TError,
  { data: ManagementReportRequest },
  TContext
> => {
  const mutationOptions =
    useExportExportManagementReportWordMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportDeclinedAssignmentsHook = () => {
  const exportExportDeclinedAssignments = useCustomInstance<Blob>();

  return useCallback(
    (declinedAssignmentsExportRequest: DeclinedAssignmentsExportRequest) => {
      return exportExportDeclinedAssignments({
        url: `/api/Export/ExportDeclinedAssignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: declinedAssignmentsExportRequest,
        responseType: 'blob',
      });
    },
    [exportExportDeclinedAssignments]
  );
};

export const useExportExportDeclinedAssignmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportDeclinedAssignmentsHook>>
    >,
    TError,
    { data: DeclinedAssignmentsExportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportDeclinedAssignmentsHook>>
  >,
  TError,
  { data: DeclinedAssignmentsExportRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportDeclinedAssignments =
    useExportExportDeclinedAssignmentsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportDeclinedAssignmentsHook>>
    >,
    { data: DeclinedAssignmentsExportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportDeclinedAssignments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportDeclinedAssignmentsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportDeclinedAssignmentsHook>>>
>;
export type ExportExportDeclinedAssignmentsMutationBody =
  DeclinedAssignmentsExportRequest;
export type ExportExportDeclinedAssignmentsMutationError = unknown;

export const useExportExportDeclinedAssignments = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExportExportDeclinedAssignmentsHook>>
    >,
    TError,
    { data: DeclinedAssignmentsExportRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useExportExportDeclinedAssignmentsHook>>
  >,
  TError,
  { data: DeclinedAssignmentsExportRequest },
  TContext
> => {
  const mutationOptions =
    useExportExportDeclinedAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportETAAccuracyHook = () => {
  const exportExportETAAccuracy = useCustomInstance<Blob>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return exportExportETAAccuracy({
        url: `/api/Export/ExportETAAccuracy`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
        responseType: 'blob',
      });
    },
    [exportExportETAAccuracy]
  );
};

export const useExportExportETAAccuracyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportETAAccuracyHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportETAAccuracyHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportETAAccuracy = useExportExportETAAccuracyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportETAAccuracyHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportETAAccuracy(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportETAAccuracyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportETAAccuracyHook>>>
>;
export type ExportExportETAAccuracyMutationBody = KPIFilterRequestModelBody;
export type ExportExportETAAccuracyMutationError = unknown;

export const useExportExportETAAccuracy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportETAAccuracyHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportETAAccuracyHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useExportExportETAAccuracyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportExportUsersHook = () => {
  const exportExportUsers = useCustomInstance<Blob>();

  return useCallback(
    (exportUsersRequest: ExportUsersRequest) => {
      return exportExportUsers({
        url: `/api/Export/ExportUsers`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: exportUsersRequest,
        responseType: 'blob',
      });
    },
    [exportExportUsers]
  );
};

export const useExportExportUsersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportUsersHook>>>,
    TError,
    { data: ExportUsersRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportExportUsersHook>>>,
  TError,
  { data: ExportUsersRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportExportUsers = useExportExportUsersHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportExportUsersHook>>>,
    { data: ExportUsersRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportExportUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportUsersMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportExportUsersHook>>>
>;
export type ExportExportUsersMutationBody = ExportUsersRequest;
export type ExportExportUsersMutationError = unknown;

export const useExportExportUsers = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportExportUsersHook>>>,
    TError,
    { data: ExportUsersRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportExportUsersHook>>>,
  TError,
  { data: ExportUsersRequest },
  TContext
> => {
  const mutationOptions = useExportExportUsersMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportInitiateGdprExportHook = () => {
  const exportInitiateGdprExport =
    useCustomInstance<InitiateGdprExportResponse>();

  return useCallback(
    (initiateGdprExportRequest: InitiateGdprExportRequest) => {
      return exportInitiateGdprExport({
        url: `/api/Export/InitiateGdprExport`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initiateGdprExportRequest,
      });
    },
    [exportInitiateGdprExport]
  );
};

export const useExportInitiateGdprExportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportInitiateGdprExportHook>>>,
    TError,
    { data: InitiateGdprExportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExportInitiateGdprExportHook>>>,
  TError,
  { data: InitiateGdprExportRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const exportInitiateGdprExport = useExportInitiateGdprExportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExportInitiateGdprExportHook>>>,
    { data: InitiateGdprExportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportInitiateGdprExport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportInitiateGdprExportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportInitiateGdprExportHook>>>
>;
export type ExportInitiateGdprExportMutationBody = InitiateGdprExportRequest;
export type ExportInitiateGdprExportMutationError = unknown;

export const useExportInitiateGdprExport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportInitiateGdprExportHook>>>,
    TError,
    { data: InitiateGdprExportRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExportInitiateGdprExportHook>>>,
  TError,
  { data: InitiateGdprExportRequest },
  TContext
> => {
  const mutationOptions = useExportInitiateGdprExportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExportGetGdprExportStatusHook = () => {
  const exportGetGdprExportStatus = useCustomInstance<GdprExportStatusDto>();

  return useCallback(
    (params?: ExportGetGdprExportStatusParams, signal?: AbortSignal) => {
      return exportGetGdprExportStatus({
        url: `/api/Export/GetGdprExportStatus`,
        method: 'GET',
        params,
        signal,
      });
    },
    [exportGetGdprExportStatus]
  );
};

export const getExportGetGdprExportStatusQueryKey = (
  params?: ExportGetGdprExportStatusParams
) => {
  return [
    `/api/Export/GetGdprExportStatus`,
    ...(params ? [params] : []),
  ] as const;
};

export const useExportGetGdprExportStatusQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>
  >,
  TError = unknown,
>(
  params?: ExportGetGdprExportStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportGetGdprExportStatusQueryKey(params);

  const exportGetGdprExportStatus = useExportGetGdprExportStatusHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>>
  > = ({ signal }) => exportGetGdprExportStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportGetGdprExportStatusQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>>
>;
export type ExportGetGdprExportStatusQueryError = unknown;

export const useExportGetGdprExportStatus = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>
  >,
  TError = unknown,
>(
  params?: ExportGetGdprExportStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportStatusHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExportGetGdprExportStatusQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExportGetGdprExportsByUserHook = () => {
  const exportGetGdprExportsByUser = useCustomInstance<GdprExportStatusDto[]>();

  return useCallback(
    (params?: ExportGetGdprExportsByUserParams, signal?: AbortSignal) => {
      return exportGetGdprExportsByUser({
        url: `/api/Export/GetGdprExportsByUser`,
        method: 'GET',
        params,
        signal,
      });
    },
    [exportGetGdprExportsByUser]
  );
};

export const getExportGetGdprExportsByUserQueryKey = (
  params?: ExportGetGdprExportsByUserParams
) => {
  return [
    `/api/Export/GetGdprExportsByUser`,
    ...(params ? [params] : []),
  ] as const;
};

export const useExportGetGdprExportsByUserQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>
  >,
  TError = unknown,
>(
  params?: ExportGetGdprExportsByUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportGetGdprExportsByUserQueryKey(params);

  const exportGetGdprExportsByUser = useExportGetGdprExportsByUserHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>>
  > = ({ signal }) => exportGetGdprExportsByUser(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportGetGdprExportsByUserQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>>
>;
export type ExportGetGdprExportsByUserQueryError = unknown;

export const useExportGetGdprExportsByUser = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>
  >,
  TError = unknown,
>(
  params?: ExportGetGdprExportsByUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportGetGdprExportsByUserHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExportGetGdprExportsByUserQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExportDownloadGdprExportHook = () => {
  const exportDownloadGdprExport = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExportDownloadGdprExportParams, signal?: AbortSignal) => {
      return exportDownloadGdprExport({
        url: `/api/Export/DownloadGdprExport`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
      });
    },
    [exportDownloadGdprExport]
  );
};

export const getExportDownloadGdprExportQueryKey = (
  params?: ExportDownloadGdprExportParams
) => {
  return [
    `/api/Export/DownloadGdprExport`,
    ...(params ? [params] : []),
  ] as const;
};

export const useExportDownloadGdprExportQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>
  >,
  TError = unknown,
>(
  params?: ExportDownloadGdprExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportDownloadGdprExportQueryKey(params);

  const exportDownloadGdprExport = useExportDownloadGdprExportHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>>
  > = ({ signal }) => exportDownloadGdprExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportDownloadGdprExportQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>>
>;
export type ExportDownloadGdprExportQueryError = unknown;

export const useExportDownloadGdprExport = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>
  >,
  TError = unknown,
>(
  params?: ExportDownloadGdprExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExportDownloadGdprExportHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExportDownloadGdprExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
